import { api, 
  getWithOptionalAuthorization, 
  putWithOptionalAuthorization, 
  postWithOptionalAuthorization,
  deleteWithOptionalAuthorization,
  patchWithOptionalAuthorization } from './api';
import { SECTION_BASE } from './apiConstant';
import { getToken } from './auth';
import { decryptMessage } from '../utils/decrypt';

export type SectionUpdateParams = {
  id: string;
  sectionName?: string;
  sectionOrder?: number;
};

export type SectionPostParams = {
  sectionName?: string;
};

export type SectionPatchBody = {
  id: string;
  sectionName?: string;
};


const sectionApi = {

  getSection : async (): Promise<any> => {
    try {
      const encryptedSectionResponse = await getWithOptionalAuthorization(`${SECTION_BASE}`, true);
      const sectionResponse = await decryptMessage(encryptedSectionResponse.data.Data, getToken());
      return sectionResponse;
    } catch (error) {
      console.error('Error fetching get section:', error);
      throw error;
    }
  },

  putSection: async (body: SectionUpdateParams[]) => {
    const response = await putWithOptionalAuthorization(`${SECTION_BASE}`, body, true);
    return response;
  },

  deleteSection: async (id: string) => {
    const response = await deleteWithOptionalAuthorization(`${SECTION_BASE}/${id}`, true);
    return response;
  },

  postSection: async (body: SectionPostParams) => {
    const response = await postWithOptionalAuthorization(`${SECTION_BASE}`, body, true);
    return response;
  },

  patchSection: async (body: SectionPatchBody) => {
    const response = await patchWithOptionalAuthorization(`${SECTION_BASE}`, body, true);
    return response;
  }
};

export default sectionApi;